import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import "./style/Cart.css";
import toast, { Toaster } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Modal } from "react-bootstrap";
import "./style/customermodel.css";
import { Tooltip } from "bootstrap";
import { Link } from "react-router-dom";
import {
  addToCart as apiAddToCart,
} from "../ProductDetail/service/productcart.service";

import {
  getCustomers,
} from "./service/Customers.service";

import {
  persistCartContext,
} from "../Checkout/service/cart.service";

import {
  addToCart,
  setCartCount,
} from "./redux/cartSlice";

import {
  getCartCount,
} from "../../Component/header/service/CartCount.service";

import {
  addToWishlist,
  fetchWishlist,
} from "../Pages/wishlist/redux/wishlistSlice";
import { useSearchParams } from "react-router-dom";
function CartList({
  sizes = [],
  loading = false,
}) {
  const dispatch = useDispatch();

  const [loadingId, setLoadingId] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [customQuantity, setCustomQuantity] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);
  const [wishlistLoadingId, setWishlistLoadingId] = useState(null);
  const [activeCartButtons, setActiveCartButtons] = useState({});
  const [activeWishlistButtons, setActiveWishlistButtons] = useState({});
  const [quantityUpdated, setQuantityUpdated] = useState({});
  const [searchParams] = useSearchParams();

  /*
  =====================================================
  DEFAULT QUANTITY
  =====================================================
  */

    const comingsoon = Number(searchParams.get("comingsoon") || 0);
  
  useEffect(() => {
    if (!sizes?.length) {
      return;
    }

    setQuantities((prev) => {
      const next = {
        ...prev,
      };

      sizes.forEach((item) => {
        const productId =
          item.product_id ||
          item.product_listing_id;

        const stock = Number(
          item.avail_stock || 0
        );

        if (
          productId &&
          stock > 0 &&
          (!next[productId] ||
            Number(next[productId]) > stock)
        ) {
          next[productId] = 0;
        }
      });

      return next;
    });
  }, [sizes]);

  /*
  =====================================================
  REFRESH CART COUNT FROM API
  =====================================================
  */
  const refreshCartCount = useCallback(
    async (customerId) => {
      try {
        if (!customerId) {
          dispatch(setCartCount(0));
          return;
        }
        const cartType =  comingsoon ? "pre" : "fresh";
        const response =
          await getCartCount(
            cartType,
            customerId
          );
        /*
        * Different API response formats handle
        */
        const count = Number(
          response?.count ??
          response?.data?.count ??
          response?.data?.data?.count ??
          0
        );
        dispatch(
          setCartCount(count)
        );
        window.dispatchEvent(
          new Event("cartUpdated")
        );

        return count;
      } catch (error) {
        console.error(
          "Refresh Cart Count Error:",
          error
        );
      }
    },
    [dispatch, comingsoon]
  );

  /*
  =====================================================
  ADD TO CART
  =====================================================
  */
  const handleAddToCart = async (item, selectedQty = null) => {
    const productId = item.product_id || item.product_listing_id;
    const stock = Number(item.avail_stock || 0);
    const quantity = Number(
      selectedQty !== null
        ? selectedQty
        : quantities[productId] ?? 0
    );

    if (quantity <= 0) {
      toast.error("Please select quantity");
      return;
    }

    if (stock <= 0) {
      toast.error("Product is out of stock");
      return;
    }

    if (quantity > stock) {
      toast.error(`Only ${stock} stock available`);
      setQuantities((prev) => ({
        ...prev,
        [productId]: stock,
      }));
      return;
    }

    setLoadingId(productId);

    try {
      const savedCustomer = JSON.parse(
        localStorage.getItem("selectedCustomer") || "null"
      );
      const cartRes = await getCartCount(
        comingsoon ? "pre" : "fresh",
        1,
        savedCustomer?.id ?? null
      );

      const existingCustomerId =  cartRes?.data?.customer_id;

      if (existingCustomerId>0) {
        const payload = {
          cart_type: comingsoon ? "pre" : "fresh",
          customer_id: Number(existingCustomerId),
          product_listing_id:
            item.product_listing_id ||
            item.product_id,
          qty: quantity,
        };

        const res = await apiAddToCart(payload);

        if (res?.success) {
          persistCartContext({
            cartType: payload.cart_type,
            userId: payload.user_id,
            customerId: payload.customer_id,
          });

          dispatch(
            addToCart({
              ...item,
              quantity,
              qty: quantity,
            })
          );

          setActiveCartButtons((prev) => ({
            ...prev,
            [productId]: true,
          }));

          /*
          ======================================
          REFRESH CART COUNT
          ======================================
          */
          await refreshCartCount(
            payload.customer_id
          );

          window.dispatchEvent(
            new Event("cartUpdated")
          );

          toast.success(
            `${quantity} added to cart`
          );
        } else {
          toast.error(
            res?.message ||
            "Failed to add cart"
          );
        }

        return;
      }

      /*
      ==========================================
      NO CUSTOMER SELECTED
      ==========================================
      */
      const customerMasterlist = await getCustomers("");
      setCustomers(
        Array.isArray(customerMasterlist) ? customerMasterlist : []
      );

      setSelectedItem(item);
      setSearch("");
      setShowModal(true);

    } catch (error) {
      console.error(
        "Add To Cart Error:",
        error
      );

      toast.error(
        error?.message ||
        "Something went wrong"
      );
    } finally {
      setLoadingId(null);
    }
  };

  /*
  =====================================================
  CUSTOMER SELECT
  =====================================================
  */
  const handleCustomerSelect =
    async (customer) => {
      if (!selectedItem) {
        return;
      }

      const productId =
        selectedItem.product_id ||
        selectedItem.product_listing_id;

      const stock = Number(
        selectedItem.avail_stock || 0
      );

      let qty = Number(
        quantities[productId] ?? 1
      );

      /*
      * STOCK VALIDATION
      */
      if (stock <= 0) {
        toast.error(
          "Product is out of stock"
        );
        return;
      }

      if (qty < 1) {
        qty = 1;
      }

      if (qty > stock) {
        toast.error(
          `Only ${stock} stock available`
        );
        return;
      }

      try {
        setSelectedCustomer(
          customer.id
        );

        setSearch(
          customer.accountName || ""
        );

        setShowModal(false);

        const payload = {
          cart_type: comingsoon ? "pre" : "fresh",
          customer_id:
            Number(customer.id),
          product_listing_id:
            selectedItem.product_listing_id ||
            selectedItem.product_id,
          qty,
        };
        setLoadingId(productId);
        const res =
          await apiAddToCart(
            payload
          );

        if (res?.success) {
          persistCartContext({
            cartType:
              payload.cart_type,
            userId:
              payload.user_id,
            customerId:
              payload.customer_id,
          });

          /*
          * Selected customer
          */
          localStorage.setItem(
            "selectedCustomer",
            JSON.stringify(
              customer
            )
          );

          /*
          * Redux cart
          */
          dispatch(
            addToCart({
              ...selectedItem,
              quantity: qty,
              qty,
            })
          );

          /*
          * Button active
          */
          setActiveCartButtons(
            (prev) => ({
              ...prev,
              [productId]: true,
            })
          );

          /*
          * REAL TIME COUNT
          */
          await refreshCartCount(
            payload.customer_id
          );

          /*
          * Notify header
          */
          window.dispatchEvent(
            new Event("cartUpdated")
          );

          toast.success(
            "Added to Cart"
          );
        } else {
          toast.error(
            res?.message ||
            "Failed to add cart"
          );
        }
      } catch (error) {
        console.error(
          "Customer Add Cart Error:",
          error
        );

        toast.error(
          error?.message ||
          "Something went wrong"
        );
      } finally {
        setLoadingId(null);
      }
    };

  /*
  =====================================================
  TOOLTIP
  =====================================================
  */
  useEffect(() => {
    const tooltipTriggerList =
      document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );

    tooltipTriggerList.forEach(
      (el) => {
        new Tooltip(el);
      }
    );
  }, []);

  /*
  =====================================================
  CUSTOMER SEARCH
  =====================================================
  */
  useEffect(() => {
    if (!showModal) {
      return;
    }

    const timer =
      setTimeout(async () => {
        try {
          const list =
            await getCustomers(
              search
            );

          setCustomers(
            Array.isArray(list)
              ? list
              : []
          );

          setActiveIndex(-1);
        } catch (error) {
          console.error(
            error
          );

          setCustomers([]);
        }
      }, 300);

    return () =>
      clearTimeout(timer);
  }, [
    search,
    showModal,
  ]);

  /*
  =====================================================
  HIGHLIGHT SEARCH
  =====================================================
  */
  const highlightText = (
    text = "",
    searchValue = ""
  ) => {
    const searchText =
      searchValue.trim();

    if (
      searchText.length < 1
    ) {
      return text;
    }

    const escaped =
      searchText.replace(
        /[.*+?^${}()|[\]\\]/g,
        "\\$&"
      );

    const regex =
      new RegExp(
        `(${escaped})`,
        "gi"
      );

    return text
      .split(regex)
      .map(
        (
          part,
          index
        ) =>
          part.toLowerCase() ===
            searchText.toLowerCase() ? (
            <span
              key={index}
              style={{
                fontWeight: "700",
                color: "#000",
              }}
            >
              {part}
            </span>
          ) : (
            part
          )
      );
  };

  /*
  =====================================================
  WISHLIST
  =====================================================
  */
  const handleAddWishlist =
    async (item) => {
      const customer =
        JSON.parse(
          localStorage.getItem(
            "selectedCustomer"
          ) || "null"
        );

      const payload = {
        user_id: 1,
        customer_id:
          customer?.id ?? null,
        product_listing_id:
          item.product_listing_id ||
          item.product_id,
      };

      try {
        setWishlistLoadingId(
          item.product_id
        );

        const res =
          await dispatch(
            addToWishlist(
              payload
            )
          ).unwrap();

        if (res?.success) {
          setActiveWishlistButtons(
            (prev) => ({
              ...prev,
              [item.product_id]:
                true,
            })
          );

          toast.success(
            "Added to Wishlist"
          );

          dispatch(
            fetchWishlist({
              userId:
                payload.user_id,
              customerId:
                payload.customer_id,
            })
          );
        } else {
          toast.error(
            res?.message ||
            "Failed"
          );
        }
      } catch (error) {
        toast.error(
          error?.message ||
          "Something went wrong"
        );
      } finally {
        setWishlistLoadingId(
          null
        );
      }
    };

  /*
  =====================================================
  CLOSE MODAL
  =====================================================
  */
  const handleCloseModal = () => {
    setShowModal(false);
    setSearch("");
    setCustomers([]);
    setSelectedCustomer(null);
    setSelectedItem(null);
  };

  /*
  =====================================================
  MODAL BODY
  =====================================================
  */
  useEffect(() => {
    if (showModal) {
      document.body.classList.add(
        "modal-open"
      );

      document.body.style.overflow =
        "hidden";

      document.body.style.paddingRight =
        "0px";

      document.documentElement.style.overflowY =
        "scroll";
    } else {
      document.body.classList.remove(
        "modal-open"
      );

      document.body.style.overflow =
        "";

      document.body.style.paddingRight =
        "";
    }

    return () => {
      document.body.classList.remove(
        "modal-open"
      );

      document.body.style.overflow =
        "";

      document.body.style.paddingRight =
        "";
    };
  }, [showModal]);

  /*
  =====================================================
  RENDER
  =====================================================
  */
  return (
    <>
      <div className="TableBoxcart">
        <Toaster
          position="top-right"
          reverseOrder={false}
        />

        <div className="table-responsive">
          <div className="table-box-content">

            {/* HEADER */}
            <div className="table-header-fixed">
              {loading ? (
                <Skeleton
                  height={38}
                  width="100%"
                  borderRadius={6}
                />
              ) : (
                <table className="table table-sm table-striped mb-0">
                  <thead>
                    <tr>
                      <th className="text-center">Size</th>
                      <th className="text-center">Shape</th>
                      <th
                        className="text-end"
                        style={{
                          paddingRight:
                            "10px",
                        }}
                      >
                        MRP (
                        <i className="bi bi-currency-rupee"></i>
                        )
                      </th>
                      <th className="text-center">Stock</th>
                      <th className="text-center">Ord. Qty</th>
                      <th className="text-center">Cart</th>
                      <th className="text-center">Wishlist</th>
                    </tr>
                  </thead>
                </table>
              )}
            </div>

            {/* BODY */}
            <div className="table-body-scroll">
              <table className="table table-sm mb-0">
                <tbody>
                  {loading ? (
                    Array.from({
                      length: 2,
                    }).map(
                      (_, index) => (
                        <tr
                          key={
                            index
                          }
                        >
                          <td>
                            <Skeleton
                              width={
                                50
                              }
                            />
                          </td>

                          <td>
                            <Skeleton
                              width={
                                80
                              }
                            />
                          </td>

                          <td>
                            <Skeleton
                              width={
                                60
                              }
                            />
                          </td>

                          <td>
                            <Skeleton
                              width={
                                40
                              }
                            />
                          </td>

                          <td>
                            <Skeleton
                              width={
                                60
                              }
                            />
                          </td>

                          <td>
                            <Skeleton
                              width={
                                50
                              }
                            />
                          </td>

                          <td>
                            <Skeleton
                              circle
                              width={
                                35
                              }
                              height={
                                35
                              }
                            />
                          </td>
                        </tr>
                      )
                    )
                  ) : sizes.length > 0 ? (
                    sizes.map(
                      (item) => {
                        const productId =
                          item.product_id ||
                          item.product_listing_id;

                        const stock =
                          Number(
                            item.avail_stock ||
                            0
                          );

                        return (
                          <tr
                            key={
                              productId
                            }
                          >
                            {/* SIZE */}
                            <td>
                              <Link
                                to="#"
                                className="size-tooltip"
                                onMouseEnter={(
                                  e
                                ) => {
                                  const tooltip =
                                    e.currentTarget.querySelector(
                                      ".tooltip-barcode"
                                    );

                                  if (
                                    !tooltip
                                  ) {
                                    return;
                                  }

                                  const rect =
                                    e.currentTarget.getBoundingClientRect();

                                  tooltip.style.left = `${rect.left +
                                    rect.width /
                                    2
                                    }px`;

                                  tooltip.style.top = `${rect.top -
                                    8
                                    }px`;
                                }}
                                onClick={(
                                  e
                                ) =>
                                  e.preventDefault()
                                }
                              >
                                {
                                  item.size
                                }

                                <span className="tooltip-barcode">
                                  {
                                    item.barcode
                                  }
                                </span>
                              </Link>
                            </td>

                            {/* SHAPE */}
                            <td>
                              {
                                item.shape
                              }
                            </td>

                             {/* MRP */}
                            <td
                              className="text-end"
                              style={{
                                paddingRight:
                                  "10px",
                              }}
                            >
                              {
                                item.mrp
                              }
                            </td>

                            {/* STOCK */}
                            <td className="text-center">
                              {
                                item.avail_stock
                              }
                            </td>

                            {/* QUANTITY */}
                            <td className="text-center">
  {stock <= 0 ? (
    <span className="text-danger">
      Out of stock
    </span>
  ) : customQuantity[productId] ? (
    <input
  type="text"
  inputMode="numeric"
  autoFocus
  className="form-control form-control-sm text-center select-List"
  value={quantities[productId] ?? ""}
  onChange={(e) => {
    const value = e.target.value;

    // Only numbers
    if (!/^\d*$/.test(value)) {
      return;
    }

    // User jo type karega wahi rahega
    setQuantities((prev) => ({
      ...prev,
      [productId]: value,
    }));

    // Quantity change hote hi Update show
    setQuantityUpdated((prev) => ({
      ...prev,
      [productId]: true,
    }));

    // Stock se zyada hai to value change nahi hogi
    if (value !== "" && Number(value) > stock) {
      toast.error(`Only ${stock} stock available`);
    }
  }}
  onBlur={() => {
    const value = quantities[productId];

    if (value === "" || value == null) {
      setQuantities((prev) => ({
        ...prev,
        [productId]: 1,
      }));
      return;
    }

    const numericValue = Number(value);

    if (numericValue > stock) {
      toast.error(`Only ${stock} stock available`);
      return;
    }

    setQuantities((prev) => ({
      ...prev,
      [productId]: numericValue,
    }));
  }}
/>
  ) : (
    <select
      className="form-control form-control-sm text-center select-List"
      value={quantities[productId] ?? 0}
      onChange={async (e) => {
        const value = e.target.value;

        // ================================
        // 10+ SELECTED
        // ================================
        if (value === "10+") {
          setCustomQuantity((prev) => ({
            ...prev,
            [productId]: true,
          }));

          // Input me 10 dikhega
          setQuantities((prev) => ({
            ...prev,
            [productId]: 10,
          }));

          return;
        }

        const qty = Number(value);

        // ================================
        // BACK TO SELECT
        // ================================
        setCustomQuantity((prev) => {
          const next = { ...prev };
          delete next[productId];
          return next;
        });

        // ================================
        // STOCK VALIDATION
        // ================================
        if (qty > stock) {
          toast.error(`Only ${stock} stock available`);

          // Stock par force nahi karna
          setQuantities((prev) => ({
            ...prev,
            [productId]: qty,
          }));

          return;
        }

        setQuantities((prev) => ({
          ...prev,
          [productId]: qty,
        }));

        // ================================
        // AUTO ADD 1-9
        // ================================
        if (qty >= 1 && qty <= 9) {
          await handleAddToCart(item, qty);
        }
      }}
    >
      {/* 0 to 9 */}
      {Array.from(
        {
          length: Math.min(10, stock + 1),
        },
        (_, i) => i
      ).map((qty) => (
        <option key={qty} value={qty}>
          {qty}
        </option>
      ))}

      {/* 10+ */}
      {stock >= 10 && (
        <option value="10+">
          10+
        </option>
      )}
    </select>
  )}
</td>
                           

                            {/* CART */}
                            <td className="text-center">
                                  <button
                                  type="button"
                                  className={`btn btn-sm addtocart ${
                                    quantityUpdated[productId]
                                      ? "btn-update"
                                      : activeCartButtons[productId]
                                      ? "btn-success"
                                      : "btn-outline-secondary"
                                  }`}
                                  onClick={async () => {
                                    const qty = Number(quantities[productId] ?? 0);

                                    if (qty <= 0) {
                                      toast.error("Please select quantity");
                                      return;
                                    }

                                    if (qty > stock) {
                                      toast.error(`Only ${stock} stock available`);
                                      return;
                                    }
                                    await handleAddToCart(item, qty);
                                    setQuantityUpdated((prev) => ({
                                      ...prev,
                                      [productId]: false,
                                    }));
                                  }}
                                  disabled={
                                    loadingId === productId ||
                                    stock <= 0 ||
                                    !quantities[productId] ||
                                    Number(quantities[productId]) <= 0 ||
                                    Number(quantities[productId]) > stock
                                  }
                                  >
                                  {loadingId === productId ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  ) : quantityUpdated[productId] ? (
                                    <>
                                      <i className="bi bi-arrow-repeat me-1"></i>
                                      {/* <span className="cart-update-text">
                                        Update
                                      </span> */}
                                    </>
                                  ) : (
                                    <i className="bi bi-cart-plus" />
                                  )}
                                  </button>
                            </td>

                            {/* WISHLIST */}
                            <td className="text-center">
                              <button
                                type="button"
                                className={`btn WishListbtn ${activeWishlistButtons[
                                    productId
                                  ]
                                    ? "wishlist-active"
                                    : "btn-outline-secondary"
                                  }`}
                                onClick={() =>
                                  handleAddWishlist(
                                    item
                                  )
                                }
                                disabled={
                                  wishlistLoadingId ===
                                  productId
                                }
                              >
                                {wishlistLoadingId ===
                                  productId ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <i
                                    className={`bi ${activeWishlistButtons[
                                        productId
                                      ]
                                        ? "bi-heart-fill"
                                        : "bi-heart"
                                      }`}
                                  />
                                )}
                              </button>
                            </td>
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td
                        colSpan="7"
                        className="text-center py-3"
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* CUSTOMER MODAL */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop={true}
        keyboard={true}
        centered={false}
        restoreFocus={false}
        dialogClassName="customer-modal-dialog"
        contentClassName="customer-modal-content"
      >
        <Modal.Body className="p-0">
          <div className="position-relative serchlistdata pt-2">
            <input
              type="search"
              className="form-control"
              placeholder="Search Customer..."
              autoFocus
              value={search}
              style={{
                borderRadius:
                  "5px",
                fontSize: "13px",
                height: "35px",
                marginTop:
                  "20%",
                width: "90%",
              }}
              onChange={(e) => {
                setSearch(
                  e.target.value
                );
                setActiveIndex(
                  -1
                );
              }}
              onKeyDown={(e) => {
                const filtered =
                  customers.filter(
                    (item) =>
                      item.accountName
                        ?.toLowerCase()
                        .includes(
                          search.toLowerCase()
                        )
                  );

                if (
                  e.key ===
                  "ArrowDown"
                ) {
                  e.preventDefault();

                  setActiveIndex(
                    (prev) =>
                      prev <
                        filtered.length -
                        1
                        ? prev + 1
                        : prev
                  );
                }

                if (
                  e.key ===
                  "ArrowUp"
                ) {
                  e.preventDefault();

                  setActiveIndex(
                    (prev) =>
                      prev > 0
                        ? prev - 1
                        : 0
                  );
                }

                if (
                  e.key ===
                  "Enter" &&
                  activeIndex >= 0
                ) {
                  e.preventDefault();

                  handleCustomerSelect(
                    filtered[
                    activeIndex
                    ]
                  );
                }
              }}
            />

            {search && (
              <div
                className="position-absolute"
                style={{
                  top:
                    "calc(100% - 1px)",
                  left: 0,
                  right: 0,
                  maxHeight:
                    "250px",
                  overflowY:
                    "auto",
                  background:
                    "#fff",
                  border:
                    "1px solid #dee2e6",
                  borderTop:
                    "none",
                  borderRadius:
                    "0 0 6px 6px",
                  boxShadow:
                    "rgba(0,0,0,0.15) 0 15px 12px",
                  zIndex: 9999,
                  width: "85%",
                  fontSize: "13px",
                }}
              >
                {customers.length >
                  0 ? (
                  customers.map(
                    (
                      customer,
                      index
                    ) => (
                      <div
                        key={
                          customer.id
                        }
                        onClick={() =>
                          handleCustomerSelect(
                            customer
                          )
                        }
                        onMouseEnter={() =>
                          setActiveIndex(
                            index
                          )
                        }
                        style={{
                          padding:
                            "5px 12px",
                          cursor:
                            "pointer",
                          background:
                            activeIndex ===
                              index
                              ? "#ededed"
                              : "#fff",
                          borderBottom:
                            "1px solid #ddd",
                        }}
                      >
                        {highlightText(
                          customer.accountName,
                          search
                        )}
                      </div>
                    )
                  )
                ) : (
                  <div
                    style={{
                      padding: 10,
                      textAlign:
                        "center",
                    }}
                  >
                    No customer found
                  </div>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default CartList;